$(document).ajaxError(function (event, jqxhr, settings, thrownError) {
   if (jqxhr.status === 401) {
        document.location.href = '/';
   }
});

$.fn.select2.defaults.set( "theme", "bootstrap4" );

window.initSelect2 = function() {
    $('.select2').each(function(index, el){
        let conf = $.extend({}, $(el).data('config'));
        $(el).select2(conf);
    });
}


window.fireAlert = function(title, message, type) {
    SwalToast.fire({
        title: title,
        text: message,
        icon: type,
        confirmButtonText: 'OK'
    });
}

window.initComponents = function() {
    initSelect2();
    $('[data-toggle="popover"]').each((index, el) => {
        let conf = $.extend({
            "trigger": "hover",
            "container": "body",
            "placement": "left",
            "html": true
        }, $(el).data());

        $(el).popover('dispose')
        $(el).popover(conf);
    })

    $("[id^='tooltip']").tooltip('hide');

    findAndshowCharCounts();
}

window.dt_options = {

	"initComplete" : function(settings, data){
        initComponents();
    },

    "drawComplete" : function(settings, data){
        initComponents();
    }
}


$(document).ready(function(){

    $('.counter').each(function () {
        var $this = $(this);
        jQuery({ Counter: 0 }).animate({ Counter: $this.text() }, {
            duration: 1000,
            easing: 'swing',
            step: function () {
                $this.text(Math.ceil(this.Counter));
            }
        });
    });

    initComponents();
});


window.addEventListener('initComponents',function () {
    setTimeout(() => {
        
        initComponents();
    }, 100);
})



const charCountTargetClass = "char-count";
    // Event delegation for dynamic inputs
$(document).on("input", "." + charCountTargetClass, function () {
    const $input = $(this);
    showCharCount($input);
});

function findAndshowCharCounts() {
    $("." + charCountTargetClass).each(function () {
        showCharCount($(this));
    });
}

function showCharCount($input) {
    // Replace multiple spaces with a single space
    let newValue = $input.val();
    
    newValue = newValue.replace("\n", '*newlineChar*');
    newValue = newValue.replace(/\s{2,}/g, " ");
    newValue = newValue.replace('*newlineChar*', "\n");
    if ($input.val() !== newValue) {
        $input.val(newValue);
    }

    newValue = newValue.trim(); // Remove leading and trailing spaces

    // Find or create counter div
    let $counter = $input.next(".char-counter");

    if ($counter.length === 0) {
        $counter = $("<div class='char-counter'></div>").css({
            "font-size": "12px",
            "color": "#555",
            "margin-top": "4px"
        });
        $input.after($counter);
    }

    // Update character count
    $counter.text("Characters: " + newValue.length);
}